import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface InquiryData {
  name: string;
  email: string;
  caseType: string;
  message: string;
}

const InquiryForm: React.FC = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState<InquiryData>({ name: '', email: '', caseType: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:7016/api';
      const response = await fetch(`${apiUrl}/InquiryFunction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error('Server error');
      setSubmitted(true);
    } catch (err) {
      setError(t('inquiry.errorMessage'));
    }
  };

  if (submitted) return <div className="container"><div className="success">{t('inquiry.successMessage')}</div></div>;

  return (
    <div className="container">
      <form className="inquiry-form" onSubmit={handleSubmit}>
      <h2>{t('inquiry.title')}</h2>
      {error && <div className="error">{error}</div>}
      <label>{t('inquiry.name')}
        <input name="name" value={form.name} onChange={handleChange} required />
      </label>
      <label>{t('inquiry.email')}
        <input name="email" type="email" value={form.email} onChange={handleChange} required />
      </label>
      <label>{t('inquiry.caseType')}
        <select name="caseType" value={form.caseType} onChange={handleChange} required>
          <option value="">{t('inquiry.caseTypePlaceholder')}</option>
          <option value="default">{t('inquiry.caseTypeDefault')}</option>
          <option value="family">{t('inquiry.caseTypeFamily')}</option>
          <option value="immigration">{t('inquiry.caseTypeImmigration')}</option>
          <option value="other">{t('inquiry.caseTypeOther')}</option>
        </select>
      </label>
      <label>{t('inquiry.message')}
        <textarea name="message" value={form.message} onChange={handleChange} required />
      </label>
      <button type="submit">{t('inquiry.submit')}</button>
      </form>
    </div>
  );
};

export default InquiryForm;
